import Parse from "parse";

export async function signIn(email, password) {
  try {
    if (Parse.User.current()) {
      logOut()
      localStorage.clear()
    }

    var user = await getUserByEmail(email)

    if (user.length === 0) {
      throw new Error("Incorrect email address!")
    }

    user = user[0]
    var username = user.get("username")
    var role = user.get("role")

    if (username.length > 0 && role !== undefined) {
      return Parse.User.logIn(username, password)
    } else {
      throw new Error("Invalid email or password!")
    }
  } catch (error) {
    throw new Error(error.message)
  }
}

async function getUserByEmail(email) {
  try {
    const result = await Parse.Cloud.run("fetchUserByEmail", { email })
    return [result]
  } catch (error) {
    throw error
  }
}

export function logOut() {
  return Parse.User.logOut()
}

export function getCurrentAdmin() {
  const user = Parse.User.current()
  return {
    name: `${user.get("name")} ${user.get("surname")}`,
    image: `${user.get("avatar").url()}`
  }
}
